<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span>{{ traducao(params.value) }}</span>
    </vs-chip>
</template>

<script>
    export default {
        name: 'CellRendererStatus',
        computed: {
          chipColor() {
            return (value) => {
              if(value === "authorized" || value === "paid") return "success"
              else if(value === "abandoned" || value === "voided" || value === "refunded") return "danger"
              else if(value === "pending") return "warning"
              else return "primary"
            }
          },
          traducao() {
            return (value) => {
              if(value === "authorized" || value === "paid") return "pago"
              else if(value === "abandoned") return "abandonado"
              else if(value === "voided") return "cancelado"
              else if(value === "refunded") return "reembolsado"
              else return "pendente"
            }
          }
        }
    }
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
